import type { RankingEntry } from '@db/types/UserGameStats';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { RankingTable } from '@/components/Ranking/RankingTable';
import { dummyRankingData } from '@/consts/dummyRankingData';
import { useScoreSave } from '@/hooks/useScoreSave';
import { useAuthStore } from '@/store/authStore';
import { fetchRanking } from '@/utils/fetchRanking';

function ResultsPage() {
  const { saveState, hasPendingSave } = useScoreSave();

  const [rankingData, setRankingData] =
    useState<RankingEntry[]>(dummyRankingData);

  useEffect(() => {
    if (import.meta.env.MODE === 'development') {
      console.debug(saveState);
    }
    fetchRanking().then((data) => {
      setRankingData(data ?? dummyRankingData);
    });
  }, [saveState]);

  useEffect(() => {
    if (saveState !== 'saved') {
      return;
    }
    fetchRanking().then((data) => {
      setRankingData(data ?? dummyRankingData);
    });
  }, [saveState]);

  const handleLogin = () => {
    useAuthStore
      .getState()
      .signInWithGoogle(window.location.origin + '/results')
      .catch((e) => window.alert(`ログインに失敗しました: ${e}`));
  };

  return (
    <div className="h-svh max-w-full overflow-clip grid place-items-center">
      <div className="container px-8 md:px-0 grid gap-24 place-items-center grid-auto-rows-max">
        <h1 className="text-2xl md:text-4xl font-bold  bg-linear-to-br from-yellow-600 via-yellow-200 to-yellow-600 bg-clip-text text-transparent text-center">
          ランキング
        </h1>

        {hasPendingSave && saveState !== 'saved' && (
          <div className="grid place-items-center bg-white gap-12 border border-amber-200 rounded-lg p-[1em]">
            <div className="grid gap-8 place-items-center">
              <p className="text-center text-red-800 font-bold text-lg">
                {saveState === 'saving'
                  ? 'スコアを保存中...'
                  : 'セッションが切れました'}
              </p>
              {saveState !== 'saving' && (
                <p className="text-center text-gray-700 text-sm">
                  再度ログインするとスコアが保存されます
                </p>
              )}
            </div>
            {saveState !== 'saving' && (
              <Button onClick={handleLogin}>ログインして保存</Button>
            )}
          </div>
        )}

        <RankingTable rankingData={rankingData} />

        <div className="grid gap-16 place-items-center">
          <Button asChild>
            <Link to="/">トップに戻る</Link>
          </Button>
          <div className="bg-yellow-600 w-full h-2" />
          <Link
            to="/results/season1"
            className=" bg-linear-to-br from-yellow-600 via-yellow-200 to-yellow-600 bg-clip-text text-transparent text-md font-bold"
          >
            前回のランキングを見る
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ResultsPage;
